import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as actions from "../../../../actions/userActions";
import * as navigationActions from "../../../../actions/navigationActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as modelHelper from "../../../../helpers/modelHelper";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import Modal from "../../../global/generic/Modal";
import CancelButton from "../../../global/generic/CancelButton";
import Button from "../../../global/generic/Button";
import Input from "../../../global/generic/Input";

class EditPasswordModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            oldPassword: "",
            newPassword: "",
            isPasswordConfirmed: false,
            isPasswordUnique: true,
            confirmNewPassword: ""
        };
    }

    handleOldPasswordChange = (event) => {
        this.setState({
            oldPassword: event.target.value
        });
    };

    handleNewPasswordChange = (event) => {
        if (this.state.oldPassword === event.target.value) {
            this.setState({
                isPasswordUnique: false,
                newPassword: event.target.value
            });
            this.props.dispatchPasswordIsNotUniqueAction();
        } else {
            this.setState({
                isPasswordUnique: true,
                newPassword: event.target.value
            });
        }
    };

    handleConfirmNewPasswordChange = (event) => {
        if (
            this.state.newPassword.length > 0 &&
            this.state.confirmNewPassword.length > 0 &&
            this.state.newPassword === event.target.value
        ) {
            this.setState({
                isPasswordConfirmed: true,
                confirmNewPassword: event.target.value
            });
        } else {
            this.setState({
                isPasswordConfirmed: false,
                confirmNewPassword: event.target.value
            });
        }
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseEditPasswordModalAction();
    };

    handleEditButtonClick = () => {
        let sha256 = require("sha256");
        this.props.dispatchEditPasswordAction(
            sha256(this.state.oldPassword).toUpperCase(),
            sha256(this.state.newPassword).toUpperCase()
        );
    };

    getEditPasswordButton = () => {
        return (
            <Button
                svgBefore={imgConfirm}
                label={<Translate value="general.confirm" />}
                onClick={this.handleEditButtonClick}
                disabled={!this.state.isPasswordConfirmed}
            />
        );
    };

    getDifferenceInPasswordsValidation = () => {
        if (!this.state.isPasswordUnique) {
            return "red-warning";
        }
        return "input-dark";
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex">
                    <div className="col-4">
                        <Translate value="userSettings.oldPassword" />
                        *:
                    </div>
                    <div className="col-8">
                        <Input
                            className="col-12 primary-input"
                            type="password"
                            value={this.state.oldPassword}
                            onChange={this.handleOldPasswordChange}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                </div>
                <div className="col-12 flex">
                    <div className="col-4">
                        <Translate value="userSettings.newPassword" />
                        *:
                    </div>
                    <div className="col-8">
                        <Input
                            className={"col-12 primary-input"}
                            type="password"
                            value={this.state.newPassword}
                            onChange={this.handleNewPasswordChange}
                            onFocus={this.handleInputFocus}
                            isValid={this.state.isPasswordConfirmed}
                        />
                    </div>
                </div>
                <div className="col-12 flex">
                    <div className="col-4">
                        <Translate value="userSettings.confirmNewPassword" />
                        *:
                    </div>
                    <div className="col-8">
                        <Input
                            className="col-12 primary-input"
                            type="password"
                            value={this.state.confirmNewPassword}
                            onChange={this.handleConfirmNewPasswordChange}
                            onFocus={this.handleInputFocus}
                            disabled={!this.state.isPasswordUnique}
                            isValid={this.state.isPasswordConfirmed}
                        />
                    </div>
                </div>
            </React.Fragment>,
            "flex flex-wrap flex-row-gap-10px"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getEditPasswordButton()}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.propsId}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="userSettings.editPassword" />)}
                content={this.getContent()}
                footer={this.getFooter()}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseEditPasswordModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.EDIT_PASSWORD_MODAL));
        },
        dispatchEditPasswordAction: (oldPassword, newPassword) => {
            dispatch(actions.editPassword(oldPassword, newPassword));
        },
        dispatchPasswordIsNotUniqueAction: () => {
            dispatch(actions.passwordIsNotUniqueMessage());
        }
    };
};

export default EditPasswordModal = connect(mapStoreToProps, mapDispatchToProps)(EditPasswordModal);
